import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../../../../common/dropdown'
import { Element } from '../../../../../../../common/html/element'
import { Table } from '../../../../../../../common/table'
import { Tooltip } from '../../../../../../../common/tooltip'
import { formatVal } from '../../../../../../../helpers/value'
import {
  selectLoading,
  selectRiskDriversById,
  selectRiskDriversByIdWithCompare,
  selectRiskDriversIds,
} from '../../../../store/slice'

const arrPercentKey = ['contribution', 'relative']

// Helper functions
const isValidValue = (value) => {
  return value !== null && value !== undefined && value !== ''
}

const formatValue = (value, isPercent) => {
  if (!isValidValue(value)) return '-'
  return isPercent ? `${value}%` : value
}

const getCompareColor = (valueCompare) => {
  if (valueCompare > 0) return '#3DA967'
  if (valueCompare < 0) return '#E0505B'
  return ''
}

const formatCompareValue = (valueCompare, value, isPercent) => {
  if (isPercent) {
    if (valueCompare === undefined || valueCompare === null) return '-'
    return `${valueCompare}%`
  }

  if (!isValidValue(valueCompare)) return '-'

  const difference = valueCompare - value
  const differenceText = isNaN(difference)
    ? ''
    : `(${difference > 0 ? '+' : ''}${difference})`

  return (
    <>
      {valueCompare}
      {differenceText}
    </>
  )
}
export const RiskDriversTable = ({
  isCompare,
  isDynamicReport,
  filterTime,
}) => {
  const ids = useSelector(selectRiskDriversIds)
  const tableTitle = [
    {
      label: '#',
      key: 'stt',
      thStyle: {
        width: 5,
      },
    },
    {
      label: 'riskComponentAnalysis.riskDrivers',
      key: 'riskDriverName',
      thStyle: {
        justifyContent: 'flex-start',
      },
    },
    {
      label: 'riskComponentAnalysis.score',
      key: 'scoreValue',
      thStyle: {
        justifyContent: 'flex-end',
      },
    },
    {
      label: 'riskComponentAnalysis.contribution',
      key: 'contribution',
      thStyle: {
        justifyContent: 'flex-end',
        minWidth: '80px',
        whiteSpace: 'normal',
      },
    },
    {
      label: 'riskComponentAnalysis.median',
      key: 'median',
      thStyle: {
        justifyContent: 'flex-end',
      },
    },
    {
      label: 'riskComponentAnalysis.relative',
      key: 'relative',
      thStyle: {
        justifyContent: 'flex-end',
        minWidth: '90px',
        whiteSpace: 'normal',
      },
    },
  ]
  const isLoading = useSelector(selectLoading('riskDriver'))

  const getSchema = () => {
    return tableTitle.map((item) => {
      return {
        isI18n: true,
        title: item.label,
        colId: item.key,
        thStyle: item.thStyle,
        render: (val, { rowId, locale, colId }) => {
          if (
            rowId &&
            typeof rowId === 'string' &&
            rowId.startsWith('group__')
          ) {
            return (
              <div
                style={{
                  fontWeight: 600,
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                }}
              >
                {val}
              </div>
            )
          }

          if (['riskDriverName', 'stt'].includes(item.key)) {
            return <div style={{ textAlign: 'left' }}>{val}</div>
          }

          if (isCompare) {
            return (
              <RenderScore val={val} colId={colId} filterTime={filterTime} />
            )
          }
          return (
            <div className="textEnd">
              {val !== null && val !== undefined && val !== ''
                ? arrPercentKey.includes(item.key)
                  ? `${val}%`
                  : formatVal(val, locale, false, 0)
                : '-'}
            </div>
          )
        },
      }
    })
  }

  return (
    <Table
      isLoading={isLoading}
      ids={ids}
      isStickyFirstCol={!isDynamicReport}
      isNoDataWithHead={false}
      schema={getSchema()}
      getDataFromRedux={
        isCompare ? selectRiskDriversByIdWithCompare : selectRiskDriversById
      }
      autoHeightMax={isDynamicReport ? undefined : 780}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
    />
  )
}

const RenderScore = ({ val, colId, filterTime }) => {
  const { value, valueCompare } = val

  return (
    <>
      <Tooltip
        tooltipContent={
          <Element>
            <Element className="dFlex justifyContentEnd" style={{ gap: 4 }}>
              <Translate value="riskComponentAnalysis.comparisonPeriod1" />
              {filterTime?.to?.label}
            </Element>
            <Element className="dFlex justifyContentEnd" style={{ gap: 4 }}>
              <Translate value="riskComponentAnalysis.basePeriod1" />
              {filterTime?.from?.label}
            </Element>
          </Element>
        }
        isI18n={false}
        position={positionDropdown.TOP_CENTER}
      >
        <Element
          style={{
            textAlign: 'right',
            fontWeight: 600,
            color: getCompareColor(valueCompare - value),
          }}
        >
          {formatCompareValue(
            valueCompare,
            value,
            arrPercentKey.includes(colId),
          )}
        </Element>
      </Tooltip>
      <div style={{ textAlign: 'right', fontStyle: 'italic' }}>
        {formatValue(value, arrPercentKey.includes(colId))}
      </div>
    </>
  )
}
